<section class="w-full h-full bg-[#FAFAFA] md:px-10 md:py-16 px-4 py-8">
  <div class="container mx-auto h-full w-full">
    <div class="flex flex-col items-center justify-center gap-4">
      <h2
        i18n="services|Services heading@@services.title"
        class="md:text-3xl text-2xl font-bold text-black"
      >
        Services
      </h2>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mt-10 w-full">
      <div
        class="flex flex-col items-center justify-center border border-gray-200 rounded-2xl p-5 w-full shadow-[0px_0px_12px_0px_rgba(0,0,0,0.16)]"
      >
        <div><img src="groups.svg" alt="Groups" /></div>
        <h1
          i18n="services|Join the game card title@@services.joinTitle"
          class="text-xl font-bold text-black"
        >
          Join The Game Now!
        </h1>
        <a
          class="bg-main-blue-light flex items-center justify-center gap-2 text-white text-sm px-5 py-2.5 rounded-full cursor-pointer mt-4 w-full hover:bg-main-blue-dark transition-all duration-300 active:scale-95"
          href="https://app.yarrowpass.com/discover"
          target="_blank"
        >
          <span>
            <img src="person_add.svg" alt="Person Add" class="w-4 h-4" />
          </span>
          <span i18n="services|Add friend button@@services.addFriend">Add Friend with Us</span>
        </a>
      </div>
      <div
        class="flex flex-col items-center justify-center border border-gray-200 rounded-2xl p-5 w-full shadow-[0px_0px_12px_0px_rgba(0,0,0,0.16)]"
      >
        <div><img src="rewarded_ads.svg" alt="Rewarded Ads" /></div>
        <h1
          i18n="services|Publish your game card title@@services.publishTitle"
          class="text-xl font-bold text-black"
        >
          Publish Your Game
        </h1>
        <button
          routerLink="/lite"
          class="bg-main-blue-light flex items-center justify-center gap-2 text-white text-sm px-5 py-2.5 rounded-full cursor-pointer mt-4 w-full hover:bg-main-blue-dark transition-all duration-300 active:scale-95"
        >
          <span i18n="services|Sign up button@@services.signUp">Let's Sign Up</span>
          <span>
            <img src="open_in_new.svg" alt="Open in new tab" class="w-4 h-4" />
          </span>
        </button>
      </div>
      <div
        class="flex flex-col items-center justify-center border border-gray-200 rounded-2xl p-5 w-full shadow-[0px_0px_12px_0px_rgba(0,0,0,0.16)]"
      >
        <div><img src="handshake.svg" alt="Handshake" /></div>
        <h1
          i18n="services|Be our partner card title@@services.partnerTitle"
          class="text-xl font-bold text-black"
        >
          Be Our Partner
        </h1>
        <button
          routerLink="/organizer"
          class="bg-main-blue-light flex items-center justify-center gap-2 text-white text-sm px-5 py-2.5 rounded-full cursor-pointer mt-4 w-full hover:bg-main-blue-dark transition-all duration-300 active:scale-95"
        >
          <span i18n="services|Contact us button@@services.contactUs">Contact Us</span>
          <span>
            <img src="open_in_new.svg" alt="Open in new tab" class="w-4 h-4" />
          </span>
        </button>
      </div>
    </div>
  </div>
</section>
